export const PASSWORD_MIN_LENGTH = 12;

/** Matches the server's `max:` rule, which counts characters rather than bytes. */
export const PASSWORD_MAX_LENGTH = 128;

/** Counts code points, the way the server's `mb_strlen`-based `max:` rule does. */
export const passwordLength = (value: string): number => [...value].length;

/**
 * The server hashes the trimmed string — Lighthouse trims every argument and `setPassword` trims
 * again — so surrounding whitespace is never part of the stored password. Normalise here too, so
 * what the field validates and submits is what gets stored and what a later login is checked
 * against.
 */
export const normalizePassword = (value: string): string => value.trim();
